module.exports = __webpack_public_path__ + "static/esportone-faad070c01b6f547ce8fc976fd92e0da.png";